import { getMainDataOverrides, getLanguageQueryString } from '@/data/sanity/utils-language'
import { imageAsset, link } from '@/data/sanity/fragments'

export const fields = `
  locationData {
    ${getLanguageQueryString([
      // Images & Media
      { name: 'featuredImage', fields: imageAsset.fieldsWithDataUri },
      { name: 'images', fields: imageAsset.fieldsWithDataUri, isArray: true },

      // Location Address
      'streetAddress',
      'city',
      'state',
      'province',
      'postalCode',
      'areaTitle',
      'timeZone',
      { name: 'geo', fields: 'latitude, longitude' },

      // Contact & Navigation
      'phoneNumber',
      'googleMapsLink',
      'emailSubscribeText',

      // Reservation & Service
      {
        name: 'reservationLinks',
        isArray: true,
        fields: `
          serviceType,
          url
        `,
      },
      {
        name: 'serviceLinks',
        isArray: true,
        fields: `
          serviceType,
          url
        `,
      },

      // Hours
      'hours',
      'weeklyOpeningHours',
      {
        name: 'holidayHours',
        isArray: true,
        fields: `
          title,
          date,
          isClosed,
          openingHour,
          closingHour,
          openingHours
        `,
      },

      // Facility & Capabilities
      'hasPrivateDining',
      'hasCatering',
      { name: 'cateringLink', fields: link.fields },
      'isReservationOnly',

      // Status/Visibility
      'isComingSoon',
      'isSoftOpening',
      'isTemporarilyClosed',
      'isNew',

      // Content
      'eyebrowText',
      'heroDescription',

    ])}
  },
  ${getMainDataOverrides({
    objectSuffix: 'LocationData',
    mainObjectName: 'locationData',
    mainDataOverrides: ['title'],
  })}
`

export const fragment = (name = 'locationData') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
